/* eslint-disable lines-around-comment */
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { translate } from '../../../base/i18n/functions';
import Icon from '../../../base/icons/components/Icon';
import { IconClose } from '../../../base/icons/svg';
// @ts-ignore
import { ActionButton } from '../../../base/premeeting';
// @ts-ignore
import Label from '../Label';
// @ts-ignore
import CountryPicker from '../country-picker/CountryPicker';
const useStyles = makeStyles((theme) => {
    return {
        dialOutDialog: {
            padding: `${theme.spacing(3)}px`
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: `${theme.spacing(4)}px`
        },
        picker: {
            margin: `${theme.spacing(2)}px 0 ${theme.spacing(3)}px 0`
        }
    };
});
/**
 * This component displays the dialog from which the user can enter the
 * phone number in order to be called by the meeting.
 *
 * @param {Props} props - The props of the component.
 * @returns {React$Element}
 */
function DialOutDialog(props) {
    const { onClose, onTextButtonClick, onSubmit, t } = props;
    const classes = useStyles();
    return (React.createElement("div", { className: classes.dialOutDialog },
        React.createElement("div", { className: classes.header },
            React.createElement("div", { className: 'prejoin-dialog-title' }, t('prejoin.startWithPhone')),
            React.createElement(Icon, { className: 'prejoin-dialog-icon', onClick: onClose, role: 'button', size: 24, src: IconClose })),
        React.createElement(Label, null, t('prejoin.callMeAtNumber')),
        React.createElement("div", { className: classes.picker },
            React.createElement(CountryPicker, { onSubmit: onSubmit })),
        React.createElement(ActionButton, { className: 'prejoin-dialog-btn', onClick: onSubmit, type: 'primary' }, t('prejoin.callMe')),
        React.createElement("div", { className: 'prejoin-dialog-delimiter-container' },
            React.createElement("div", { className: 'prejoin-dialog-delimiter' }),
            React.createElement("div", { className: 'prejoin-dialog-delimiter-txt-container' },
                React.createElement("span", { className: 'prejoin-dialog-delimiter-txt' }, t('prejoin.or')))),
        React.createElement("div", { className: 'prejoin-dialog-dialin-container' },
            React.createElement(ActionButton, { className: 'prejoin-dialog-btn', onClick: onTextButtonClick, type: 'text' }, t('prejoin.iWantToDialIn')))));
}
export default translate(DialOutDialog);
